import React from "react";

export default function Nav() {
  return (
    <nav>
      <img src="/assets/images/logo.png" />
    </nav>
  );
}
